/**
 * Returns the id/field of the left "grouping" column for a reversed-axes matrix.
 *
 * When axes are reversed the transpose turns the would-be rows into columns, so
 * the grouping column holds the dimensionB values (2D) or metric names (1D)
 * rather than the dimensionA field. Both the col-def builder and the row-data
 * builder need the same field, so the mapping lives here.
 */
const getReversedGroupingField = ({
  chartDef,
  isTwoDimensional,
}: {
  chartDef: V5ChartDefinition;
  isTwoDimensional: boolean;
}): string => {
  if (isTwoDimensional && chartDef.dimensionA && chartDef.dimensionB) {
    if (chartDef.dimensionB.isGroupByDayOfWeek) return 'dayOfWeek';
    if (chartDef.dimensionB.isGroupByMonth) return 'month';
    if (chartDef.dimensionB.fieldType === 'date') return 'date';
    if (chartDef.dimensionB.rangeInput) return 'key';
    return chartDef.dimensionB.field;
  }

  return 'metric';
};

export default getReversedGroupingField;
